import * as React from "react";
import { css } from "aphrodite";
import { BlockSubTitleStyle } from "main/javascripts/components/molecules/Lp/BlockSubTitle/BlockSubTitleStyle";

export interface IProps {
  children: any;
}

export const BlockSubTitle: React.FC<IProps> = (
  props: IProps
): React.ReactElement<IProps> => {
  return <h3 className={css(BlockSubTitleStyle.title)}>{props.children}</h3>;
};
